module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAQCAYAAADAvYV+AAAAAXNSR0IArs4c6QAAAKtJREFUKFOtkk0KwjAQhb93LQ8lgi7qD57AhZewYC/gwoV4AlHwDoIIbkuVkYEGpJg0CwcCIe97ZIY3MrMtMADGkioSJTOzVn8AKz+SXr8837DrNbAB5pJuXUMXDvoeKICTpPAzMdhNV2AEHCS9/SEFu/4EhkAlqe6D3dAAa2CRA4c5ln+Hs9u4e7I5A55b8BgSjfW8A6bAJRWKx10Cs764sxYprOhEkt+j9QEXN2ULH20lgAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comp/播放.png
// module id = 7RdI
// module chunks = 3